import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { PawPrint } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { errorMessage } from "@/lib/api";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/dashboard" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try { await login(email, password); navigate("/dashboard"); }
    catch (err) { setError(errorMessage(err)); } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center px-4 relative overflow-hidden noise" data-testid="login-page">
      <div className="absolute inset-0 -z-10 bg-[radial-gradient(ellipse_at_bottom_right,rgba(16,185,129,0.15),transparent_55%)]" />
      <form onSubmit={submit} className="surface w-full max-w-sm p-8 reveal">
        <div className="flex items-center gap-2.5 font-display font-bold text-lg mb-8">
          <span className="grid h-9 w-9 place-items-center rounded-xl bg-emerald-500 text-white"><PawPrint size={20} /></span>
          Polizzapet<span className="text-emerald-500">.it</span>
        </div>
        <p className="label-mono mb-1">Area riservata</p>
        <h1 className="font-display text-2xl font-bold mb-6">Accedi al Growth Engine</h1>
        <label className="text-sm font-medium">Email</label>
        <input type="email" required className="input mt-1.5 mb-4" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email-input" autoComplete="email" />
        <label className="text-sm font-medium">Password</label>
        <input type="password" required className="input mt-1.5" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password-input" autoComplete="current-password" />
        {error && <p className="text-sm text-rose-500 mt-3" data-testid="login-error">{error}</p>}
        <button className="btn-primary w-full mt-6" disabled={loading} data-testid="login-submit-button">{loading ? "Accesso..." : "Entra"}</button>
      </form>
    </div>
  );
}
